import type { DataLayer } from '../DataLayer';
import { filterBlanks } from '../utils/filterBlanks';

import { nullify } from './nullify';

export interface UserDetails {
  authenticated?: boolean;
  trackingId?: string;
  userClientId?: string; // remove with dtm
  loginId?: string;
}

export const mapUserDetails = ({
  authenticated,
  trackingId,
  loginId,
}: UserDetails = {}): DataLayer =>
  filterBlanks({
    isLoggedIn: authenticated,
    profileGuid: trackingId,
    loginId: nullify(loginId),
  });
